import { createTheme } from "@material-ui/core/styles";
import { teal, pink } from "@material-ui/core/colors";

// Dynamically load the "Fira Sans" font
const firaSans = new FontFace(
  "Fira Sans",
  "url('https://fonts.googleapis.com/css2?family=Fira+Sans:wght@400;700&display=swap')"
);
firaSans.load().then(() => {
  document.fonts.add(firaSans);
});

const theme = createTheme({
  palette: {
    primary: {
      main: "#032736", // Set the primary color to #032736
      secondary: "#343434",
    },
  },
  typography: {
    fontFamily: "'Fira Sans', Arial, sans-serif",
  },
});

// @TODO remove
export const smallIconButton = (outerTheme) => ({
  ...outerTheme,
  overrides: {
    MuiIconButton: {
      root: {
        width: outerTheme.spacing(4),
        height: outerTheme.spacing(4),
        fontSize: outerTheme.typography.pxToRem(20),
      },
    },
  },
});

// @TODO remove
export const mediumIconButton = (outerTheme) => ({
  ...outerTheme,
  overrides: {
    ...outerTheme.overrides,
    MuiIconButton: {
      root: {
        width: outerTheme.spacing(5),
        height: outerTheme.spacing(5),
      },
    },
  },
});

// @TODO remove
export const lessPaddedExpansion = (outerTheme) => ({
  ...outerTheme,
  overrides: {
    ...outerTheme.overrides,
    MuiExpansionPanelSummary: {
      root: {
        padding: outerTheme.spacing(0, 2),
      },
    },
    MuiExpansionPanelDetails: {
      root: {
        padding: outerTheme.spacing(2, 2),
      },
    },
  },
});

export default theme;
